// @mui
import { Box, Container, Divider, Tab, Tabs, useTheme } from "@mui/material";
// routes
import { PATH_SETTINGS } from "../../routes/paths";
// hooks
import useSettings from "../../hooks/useSettings";
import useTabs from "../../hooks/useTabs";
// components
import { Outlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import Page from "../../components/Page";
import { navItems } from "./navItems";

// ----------------------------------------------------------------------

export default function SettingsLayout() {
  const { themeStretch } = useSettings();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const defaultTab = () => {
    const matchingTab = navItems.find((tab) =>
      location.pathname.includes(tab.path)
    );
    return matchingTab?.value || "general";
  };

  const { currentTab, onChangeTab } = useTabs(defaultTab());

  return (
    <Page title="Settings">
      <Container maxWidth={themeStretch ? false : "lg"}>
        <HeaderBreadcrumbs
          heading="Settings"
          homeIcon="home"
          links={[{ name: "Settings", href: PATH_SETTINGS.root }]}
        />

        <Tabs
          allowScrollButtonsMobile
          variant="scrollable"
          scrollButtons="auto"
          value={currentTab}
          onChange={onChangeTab}
          TabIndicatorProps={{
            sx: {
              height: "5px",
              borderRadius: "20px",
            },
          }}
          sx={{
            "& .Mui-selected": {
              color: `${theme.palette.primary.dark} !important`,
            },
          }}
        >
          {navItems.map((tab) => (
            <Tab
              disableRipple
              key={tab.value}
              label={tab.value}
              value={tab.value}
              onClick={() => navigate(tab.path)}
              sx={{
                ml: "10px",
              }}
            />
          ))}
        </Tabs>
        <Divider sx={{ borderColor: theme.palette.grey[500_16] }} />
        <Box sx={{ mb: 5 }} />

        <Outlet />
      </Container>
    </Page>
  );
}
